import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import { notification, Table, Input, Modal, Pagination } from 'antd';

@inject('goodsGroupStore')
@observer
class PGoodsModal extends Component {
  state = {
    groupNm: '',

    selectedRowKeys: [],
    selectedRows: []
  };

  UNSAFE_componentWillMount() {
    this.props.goodsGroupStore.setCommonStoreInfo(this.props.commonStore);
    this.props.goodsGroupStore.onClear();
    this.props.goodsGroupStore.onChangValue('useYn', 'Y');
    this.props.goodsGroupStore.disGoodsGroupList(1, 5);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalOpen !== this.props.modalOpen && nextProps.modalOpen === true) {
      this.setState({ 
        groupNm: '',

        selectedRowKeys: [],
        selectedRows: []
      });
      this.props.goodsGroupStore.disGoodsGroupList(1);
    }
  }

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.goodsGroupStore.disGoodsGroupList(pageIdx);
  };

  onSearch = () => {
    this.props.goodsGroupStore.onChangValue('groupNm', this.state.groupNm);
    this.props.goodsGroupStore.disGoodsGroupList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const {
      goodsGroupList,
      pageInfo
    } = this.props.goodsGroupStore;
    const { 
      groupNm,

      selectedRowKeys,
      selectedRows
    } = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM',  width: '10%', align: 'center' },
      { title: '상품군', dataIndex: 'groupNm', width: '50%', align: 'center' },
      { title: '상품 갯수', dataIndex: 'gdCdCnt', width: '20%', align: 'center' },
      { title: '사용여부', dataIndex: 'useYn', width: '20%', align: 'center',
        render: (item, record) => { return(
          item === "Y" ? <Fragment>사용</Fragment> : <Fragment>미사용</Fragment>
        )}
      },
    ];

    const rowSelection = {
      columnWidth: '2%',
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        this.setState({selectedRowKeys, selectedRows});
      }
    };

    return (
      <Modal
        width={600}
        title="상품군선택"
        cancelText={"취소"}
        okText={"확인"}
        closable={false}
        visible={this.props.modalOpen}
        onCancel={this.props.modalClose}
        onOk={()=>{
          if (selectedRows.length > 0) {
            this.props.setData(selectedRows[0]);
            this.props.modalClose();
          } else {
            notification.warning({placement: 'bottomLeft', message: `상품군을 선택해주세요.`, duration: 2});
          }
        }}
      >
        상품군 : 
        <Input.Search
          placeholder="상품군명을 입력하세요"
          value={groupNm}
          onChange={(e)=>this.setState({groupNm: e.target.value})}
          onPressEnter={this.onPressEnter}
          onSearch={this.onSearch}
          style={{ width: 200, marginBottom: 8 }}
        />
        <Table
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={goodsGroupList} 
          //scroll={{ x: 1300, y:300 }}
          pagination={false}
          rowSelection={{
            type: 'radio',
            ...rowSelection,
          }}
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfo !== null ? pageInfo.pageIndex : 1}
            total={pageInfo !== null ? pageInfo.totalCnt : 0}
            pageSize={pageInfo !== null ? pageInfo.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>
      </Modal>
    );
  }

}

export default withRouter(PGoodsModal);
